import React from 'react'
import { BehaviorTime, BehaviorTitle, Container, Header, HeaderDetails, HistoryButton, IconContainer } from './styles'
import { IconName } from '~/assets/icons'
import { IconComponent } from '~/assets/icons/component'

interface IProps {
  title: string
  time: string
  iconName: IconName

  showHistory?: boolean
  onClickOpenHistory?: VoidFunction

  children: React.ReactNode
}

export const BehaviorCard = ({
  children,
  title,
  time,
  showHistory,
  iconName,
  onClickOpenHistory: historyCallback
}: IProps): JSX.Element => {
  const handleOpenHistory = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (historyCallback) {
      event.stopPropagation()
      historyCallback()
    }
  }

  return (
    <Container>
      <Header>
        <IconContainer>
          <IconComponent name={iconName} />
        </IconContainer>
        <div>
          <BehaviorTitle>{title}</BehaviorTitle>
          <HeaderDetails>
            <IconComponent name={'cached'} />
            <div>
              <BehaviorTime>{time}</BehaviorTime>
              {showHistory && <HistoryButton onClick={handleOpenHistory}>histórico</HistoryButton>}
            </div>
          </HeaderDetails>
        </div>
      </Header>
      {children}
    </Container>
  )
}
